import type { Component } from 'vue'
import type { CardChildType } from '../../types'
import BarListBlock from './bar-list.vue'
import ChartBlock from './chart.vue'
import MetricBlock from './metric.vue'
import NoticeBlock from './notice.vue'
import TableBlock from './table.vue'
import TextBlock from './text.vue'

/* the block types a `card` block may hold; cards do not nest, which keeps block.vue and block-renderer.vue free of a cycle */
const BLOCK_REGISTRY: Readonly<Record<CardChildType, Component>> = {
  text: TextBlock,
  chart: ChartBlock,
  metric: MetricBlock,
  bar_list: BarListBlock,
  table: TableBlock,
  notice: NoticeBlock
}

export default BLOCK_REGISTRY
